import { StoredPlan } from "../../../@types/Billing/Plan";
import { api } from "../../api";

export default async function findAll(): Promise<StoredPlan[]> {
  try {
    const { data } = await api.get("/billing/plans");

    return data;
  } catch (err) {
    return [];
  }
}
